import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import React from "react";
import { Dropdown } from "rsuite";
import useCloudPermissions from "../../hooks/useCloudPermissions";

const PendingUserOptions = ({ user, resendInvite, removeInvite }) => {
  const { cPermissions } = useCloudPermissions();

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Resend Invite"
        onClick={() => resendInvite(user)}
        icon="mdi mdi-send"
        disabled={!cPermissions.cloud_resend_invitation}
        tooltip={
          cPermissions.cloud_resend_invitation
            ? null
            : "You don't have permission to resend invites"
        }
      ></DropdownOptionWithIcon>
      <DropdownOptionWithIcon
        name="Remove Invite"
        onClick={() => removeInvite(user, true)}
        icon="mdi mdi-delete"
        disabled={!cPermissions.cloud_delete_person}
        tooltip={
          cPermissions.cloud_delete_person
            ? null
            : "You don't have permission to remove invites"
        }
      ></DropdownOptionWithIcon>
    </PopoverDropdownMenu>
  );
};

export default PendingUserOptions;
